import { useNavigate } from 'react-router-dom';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Graph } from '../../../../components/Graph';
import { withLoadingAndOverlay } from '../../../../hoc';

function OrgEdBreakdown({ data: orgEdObject = {} }) {
  const navigate = useNavigate();

  const labels = Object.keys(orgEdObject);

  const datasets = [
    {
      label: 'Accounts',
      data: Object.values(orgEdObject),
      name: Object.keys(orgEdObject),
      hoverOffset: 4,
      backgroundColor: ['#4482FF', '#294E99', '#f3bc00', '#00af82', '#0075a4', '#0075a4'],
      borderColor: ['#4482FF', '#294E99', '#f3bc00', '#00af82', '#0075a4', '#0075a4'],
    },
  ];

  const options = {
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
    onClick: (event, chartElement) => {
      const { index } = chartElement.length && chartElement[0];
      if (index || index === 0) {
        const pieValue = Object.keys(orgEdObject) && Object.keys(orgEdObject).length ? Object.keys(orgEdObject)[index] : 0;
        navigate('/account-list', { state: { filters: { organisationEdition: [pieValue], licenceStatus: ['Active'], accountVisibility: true } } });
      }
    },
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          const sets = ctx.chart.data.datasets;
          if (sets.indexOf(ctx.dataset) === sets.length - 1) {
            const sum = sets[0].data.reduce((a, b) => a + b, 0);
            const percentage = `${Math.round((value / sum) * 100)}%`;
            return percentage;
          }
          return true;
        },
        color: '#fff',
        display: true,
      },
      legend: {
        position: 'bottom',
        align: 'center',
        labels: {
          padding: 15,
        },
        onHover(e) {
          const { style } = e.native.target;
          style.cursor = 'pointer';
        },
        onLeave(e) {
          const { style } = e.native.target;
          style.cursor = 'default';
        },
      },
      title: {
        display: true,
        text: 'Organization Edition Breakdown',
        padding: 15,
        align: 'center',
        position: 'top',
        font: {
          size: 14,
        },
      },
    },
  };

  return (
    <Graph
      type="pie"
      labels={labels}
      datasets={datasets}
      options={options}
      plugins={[ChartDataLabels]}
    />
  );
}

export default withLoadingAndOverlay(OrgEdBreakdown);
